IN.App.ApplicationAdapter = DS.FixtureAdapter;
var attr = DS.attr;

IN.App.User = DS.Model.extend({
  email      	: DS.attr()
});
